import React from "react";
import SidebarBase from "./SidebarBase";

export default function SidebarAdministracion() {
  return (
    <SidebarBase
      storageKeyMenus="administracion_menus"
      storageKeySubmenu="submenu_admin"
      storageKeyLoc="submenu_loc_admin"
      storageKeyName="submenu_name_admin"
    />
  );
}
